import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { BaseModel } from '~/shared/model'

export default class CalendarParticipant extends BaseModel {
  id: string = ''
  role: string = ''
  name: string = ''

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (isUnknownObject(data.extra_data)) {
        this.name = `${String(data.extra_data.first_name ?? '')} ${String(data.extra_data.last_name ?? '').at(0)}.`
      }
    }
  }
}
